<template>
  <!--Information Pane-->
  <div class="information document" v-if="document != null">
    <div class="title">
      <h4>{{ 'Belge Detayları'|trans }}</h4>
      <button class="close" @click="document = null"><i class="fas fa-times"></i></button>
    </div>
    <div class="details">
      <!--Document Detail-->
      <div class="item"><span class="type">{{ 'Dosya Adı:'|trans }}</span><span class="value">{{ document.name }}</span></div>
      <div class="item"><span class="type">{{ 'İmza Sayısı:'|trans }}</span><span class="value">{{ document.signatures.length || 0 }}</span></div>

      <!--Blockchain Proof Detail-->
      <template v-if="blockchainApi">
        <div class="item pb-2"><span class="type">{{ 'Blockchain:'|trans }}</span></div>
        <div class="blockchain" v-if="blockchainProof.values">
          <div class="item">
            <span class="type">{{ 'Kanıt:'|trans }}</span>
            <span class="value text-success" v-if="blockchainProof.returnStatus === 'PROOF_EXISTS'">{{ 'Kanıt mevcut.'|trans }}</span>
            <span class="value text-danger" v-else>{{ 'Kanıt bulunamadı!'|trans }}</span>
          </div>
          <div class="item" v-if="blockchainProof.returnStatus === 'PROOF_EXISTS'"><span class="type">{{ 'Şirket ID:'|trans }}</span><span class="value">{{ blockchainProof.values.companyAddr }}</span></div>
          <div class="item" v-if="blockchainProof.returnStatus === 'PROOF_EXISTS'"><span class="type">{{ 'Belge ID:'|trans }}</span><span class="value">{{ blockchainProof.values.docID }}</span></div>
          <div class="item" v-if="blockchainProof.returnStatus === 'PROOF_EXISTS'"><span class="type">{{ 'Tarih:'|trans }}</span><span class="value">{{ toLocale(blockchainProof.values.timestamp) }}</span></div>
        </div>
        <div class="blockchain" v-else>
          <div class="item">{{ 'Sunucuya bağlanılamadı!'|trans }}</div>
        </div>
      </template>
      <!--Blockchain Proof END-->
    </div>
  </div>
</template>

<script>
import Api from "../Api";

export default {
  name: "DocumentDetails",

  data: () => {
    return {
      document: null,
      blockchainProof: {
        status: null
      },
    }
  },
  created() {
    this.blockchainApi = this.$parent.$parent.blockchainApi || null;
  },
  methods: {
    /**
     * Open Information Panel
     *
     * @param document
     */
    async show(document) {
      this.$parent.progress = true;

      // Get Blockchain Proof Data
      if (this.blockchainApi && this.$parent.uplodedFiles.hasOwnProperty(document.name)) {
        let response = await Api.getFileProof(this.$parent.uplodedFiles[document.name], this.blockchainApi);
        this.blockchainProof = (response.data && response.data.returnStatus) ? response.data : {};
      }

      this.document = document;
      this.$parent.progress = false;
    },

    /**
     * TimeStamp to Locale Time Format
     *
     * @param timestamp
     * @returns {string}
     */
    toLocale(timestamp) {
      return new Date(timestamp * 1000).toLocaleString();
    }
  }
}
</script>
<style lang="scss">
.information.document {
  .details .item .type {
    flex: 1;
  }

  .blockchain {
    background: rgba(255,255,255,.1);
    padding-bottom: 15px;
    .item {
      margin-top: 15px;
      padding: 0 10px;
    }
  }
}
</style>
